module.exports = __webpack_public_path__ + "static/media/PDF8.86808a23.pdf";